
function ColourScheme() {

    let scheme = '';

    if (window.matchMedia) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            scheme = 'Dark';
        } else {
            scheme = 'Light';
        }
    }

    return (
        <div className="information_card">
            <h3>Colour scheme</h3>
            <p className="information" data-colour-scheme={scheme}>{scheme}</p>
        </div>
    );
}

export default ColourScheme;